module.exports = __webpack_public_path__ + "img/fi_eye.dfc5ff36.svg";